import axios from "axios";

function getData(data) {
    return axios.post('api/compensacion/dataTable', data);
}


function guardarCompensacion(data) {
    return axios.post('api/compensacion/guardarCompensacion', data);
}

function editarCompensacion(data) {
    return axios.put('api/compensacion/editarCompensacion', data);
}
export {
    getData,
    guardarCompensacion,
    editarCompensacion
}
